export { default as FireSolidIcon } from './FireSolidIcon';
